import styled from 'styled-components'
import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;

  @media ${baseTheme.device.tablet} {
    height: 100%;
  }
`

export const TitleTypography = styled(Typography)`
  margin-top: 26px;

  && {
    font-size: ${baseTheme.typography.fontSize['2xl']};
    font-weight: ${baseTheme.typography.fontWeight.bold};
    line-height: 130%;
    color: ${baseTheme.colors.lightDark};
  }
`

export const DescriptionTypography = styled(Typography)`
  margin-top: 8px;
  text-align: center;
  && {
    font-size: ${baseTheme.typography.fontSize.lg};
    font-weight: ${baseTheme.typography.fontWeight.regular};
    line-height: 150%;
    color: ${baseTheme.colors.lightDark};
  }
`
